import { createFileRoute } from "@tanstack/react-router"

import { RSS_FEED_LINK } from "@/lib/rss-meta"

import { HomeNewPage } from "./-components/home-new/HomeNewPage"
import { homepageCanonicalLink } from "./-components/home/homeRoute"

// The homepage uses the standard site header: its hero sits on the page
// background, not under full-bleed artwork.
export const Route = createFileRoute("/")({
  head: () => ({ links: [homepageCanonicalLink, RSS_FEED_LINK] }),
  component: IndexPage,
})

function IndexPage() {
  return <HomeNewPage />
}
